import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../../../components/button/Button";
import { Card } from "../../../components/card/Card";
import { getLinkedFirm } from "../../../sessionStorage/sessionStorage";
import {
  useLazyGetSyncDataQuery,
  useUpdateSyncDataMutation,
} from "../../../slices/QboSlice";

export const ManagementPortal = () => {
  const navigate = useNavigate();

  const [getSyncDataInfo, { data: syncDataInfo }] = useLazyGetSyncDataQuery();
  const [updateSyncData] = useUpdateSyncDataMutation();

  const [activeContact, setActiveContact] = useState(
    syncDataInfo?.syncCustomer || false,
  );
  const [activeInvoice, setActiveInvoice] = useState(
    syncDataInfo?.syncInvoice || false,
  );
  const [activePayment, setActivePayment] = useState(
    syncDataInfo?.syncPayments || false,
  );
  const [activeTime, setActiveTime] = useState(
    syncDataInfo?.syncServiceItems || false,
  );

  useEffect(() => {
    void getSyncDataInfo({
      orgId: getLinkedFirm().orgId,
    });
  }, [getLinkedFirm().orgId]);

  return (
    <div>
      <Card extraClasses={"shadow-box rounded-[6px] h-[450px]"}>
        <div className={"flex h-[90%] gap-10"}>
          <div className={"flex h-full flex-col justify-between px-5 py-4"}>
            <div className={"text-xl font-semibold"}>
              Integration Management Portal
            </div>
            <div className={"w-[300px]"}>
              <div className="mb-2 flex items-center justify-between font-semibold">
                Contact Auto-Sync{" "}
                <input
                  type="checkbox"
                  className={classNames(
                    "toggle toggle-accent mr-4 h-5 w-11",
                    activeContact
                      ? "border-[#7c66f0] bg-[#7c66f0]"
                      : "border-gray-300 bg-gray-300",
                  )}
                  checked={activeContact}
                  onChange={(e) => setActiveContact(e.target.checked)}
                />
              </div>

              <div className="mb-2 flex items-center justify-between font-semibold">
                Invoice Auto-Sync{" "}
                <input
                  type="checkbox"
                  className={classNames(
                    "toggle toggle-accent mr-4 h-5 w-11",
                    activeInvoice
                      ? "border-[#7c66f0] bg-[#7c66f0]"
                      : "border-gray-300 bg-gray-300",
                  )}
                  checked={activeInvoice}
                  onChange={(e) => setActiveInvoice(e.target.checked)}
                />
              </div>

              <div className="mb-2 flex items-center justify-between font-semibold">
                Payment Auto-Sync{" "}
                <input
                  type="checkbox"
                  className={classNames(
                    "toggle toggle-accent mr-4 h-5 w-11",
                    activePayment
                      ? "border-[#7c66f0] bg-[#7c66f0]"
                      : "border-gray-300 bg-gray-300",
                  )}
                  checked={activePayment}
                  onChange={(e) => setActivePayment(e.target.checked)}
                />
              </div>

              <div className="mb-4 flex items-center justify-between font-semibold">
                Time Auto-Sync{" "}
                <input
                  type="checkbox"
                  className={classNames(
                    "toggle toggle-accent mr-4 h-5 w-11",
                    activeTime
                      ? "border-[#7c66f0] bg-[#7c66f0]"
                      : "border-gray-300 bg-gray-300",
                  )}
                  checked={activeTime}
                  onChange={(e) => setActiveTime(e.target.checked)}
                />
              </div>
            </div>

            <div className="flex justify-start gap-5">
              <Button
                label={"Save"}
                onClick={() => {
                  updateSyncData({
                    id: syncDataInfo?.id || "",
                    syncInvoice: activeInvoice,
                    syncServiceItems: activeTime,
                    syncCustomer: activeContact,
                    syncPayments: activePayment,
                    connectWithQbo: true,
                    isSynced: true,
                  });
                  navigate("/settings/integrations");
                }}
              />
              <Button
                label={"Cancel"}
                colorType={"outline"}
                onClick={() => navigate("/settings/integrations")}
              />
            </div>
          </div>
          {/* <div
            className={
              "m-1 flex flex-col border-2 px-5 py-4 text-xl font-semibold"
            }>
            <div>Sync Report</div>
            <div>info</div>
          </div>*/}
        </div>
      </Card>
    </div>
  );
};
